import {StylesConfig} from "react-select";

export interface SelectOption {
    value: string;
    label: string;
    fullLabel: string;
}
export const customStyles: StylesConfig<SelectOption, true> = {
    control: (provided, state) => ({
        ...provided,
        cursor: "pointer",
        borderRadius: state.selectProps.menuIsOpen ? '16px 16px 0 0' : '16px',
        backgroundColor: state.selectProps.menuIsOpen ? "#FFF" : !state.hasValue ? "#FFF" : "#F7F7F7",
        border: state.isFocused ? "1px solid #1A64A5" : state.hasValue ? "1px solid #1A64A5" : "1px solid #AFAFAF",
        borderBottom: state.selectProps.menuIsOpen ?  'none' : !state.hasValue ? "1px solid #AFAFAF" : "1px solid #1A64A5",
        padding: '13.5px 16px',
        minHeight: '48px',
        zIndex: state.isFocused ? 10 : 0,
        boxShadow: 'none',
        transition: 'all .2s ease',
        '&:hover': {
            border: "1px solid #1A64A5",
            borderBottom: state.selectProps.menuIsOpen ? 'none' : "1px solid #1A64A5",
            backgroundColor: state.selectProps.menuIsOpen ? "#fff" : "#F7F7F7",
        }
    }),

    option: (provided, state) => ({
        ...provided,
        padding: '8px 0',
        color: '#363636',
        cursor: 'pointer',
        position: 'relative',
        fontSize: '16px',
        lineHeight: '130%',
        fontWeight: 400,
        borderBottom: '1px solid #AFAFAF',
        backgroundColor: 'transparent',
        '&:last-child': {
            borderBottom: 'none',
        },
        '&:hover': {
            backgroundColor: '#F7F7F7'
        }
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        padding: '0',
    }),
    menu: (provided, state) => ({
        ...provided,
        borderRadius: '0 0 16px 16px',
        boxShadow: 'none',
        marginTop: '-1px',
        zIndex: 9,
        border: '1px solid #1A64A5',
        borderTop: 'none',
        position: "static",
        width: '100%',
        backgroundColor: '#FFF'
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '0 16px 16px',
        maxHeight: '400px',
        overflowY: 'auto',
        '&::-webkit-scrollbar-track': {
            background: "transparent",
            scrollbarColor: "transparent",
        },
    }),
    placeholder: (provided, state) => ({
        ...provided,
        color: '#AFAFAF',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '130%',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '0',
    }),
    singleValue: (provided) => ({
        ...provided,
        padding: '0',
        fontFamily: '"Onest","Roboto", "Helvetica", "Arial", sans-serif',
        color: "#363636",
        fontSize: '16px',
        fontWeight: 500,
        margin: 0
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#F7F7F7',
        borderRadius: '8px',
        margin: '2px',
        maxWidth: '150px'
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#fff',
        fontSize: '14px',
        padding: '2px 8px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        backgroundColor: '#27AE60',
        borderRadius: '8px',
    }),
    multiValueRemove: () => ({
    display:"none"
    })
};